import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FaEllipsisH } from 'react-icons/fa';
import DropDownList from './DropDownList';
const styles = {
    container: css `
    position: relative;
    padding: 2px;
    border-radius: 10px;
    width: max-content;
    display: inline-block;
    border: 0.55px solid lightgray;
    font-size: 10px;
  `,
    button: css `
    width: 100%;
  `,
};
function DropDownButton(props) {
    const { data, selectedKey, onSelect, formatSelectedValue = (item) => item.label, renderItem = null, style, } = props;
    const [open, setOpen] = useState(false);
    const [item, setItem] = useState();
    const drop = useRef(null);
    useEffect(() => {
        if (selectedKey) {
            const item = data.find((i) => i.key === selectedKey) || null;
            setItem(item);
        }
    }, [selectedKey, data]);
    useEffect(() => {
        function handleClick() {
            setOpen(false);
        }
        window.addEventListener('click', handleClick);
        return () => window.removeEventListener('click', handleClick);
    }, []);
    const selectHandler = useCallback((index) => {
        setItem(data[index]);
        onSelect?.(data[index]);
    }, [data, onSelect]);
    return (_jsxs("div", { className: "dropdown", ref: drop, css: [styles.container, style], children: [_jsx("button", { css: styles.button, type: "button", onClick: (event) => {
                    setOpen((open) => !open);
                    event.stopPropagation();
                }, children: !item ? _jsx(FaEllipsisH, {}) : formatSelectedValue(item) }), open && (_jsx(DropDownList, { data: data, onSelect: selectHandler, renderItem: renderItem }))] }));
}
export default DropDownButton;
